import React, { useEffect, useState } from 'react';

import {
  DEFAULT_PARTY_TIME_NORMAL_CURVE,
  DEFAULT_TOKEN_IDO_CURVE_MIN,
} from '@/config';
import { twMerge } from 'tailwind-merge';
import { FUND_EXPIRATION_LIST } from './config';
import FormDeFaiAgentInfo from './FormDeFaiAgentInfo';

interface ModalProps {
  isOpen: boolean;
  closeModal: () => void;
  coin: any;
  onConfirm: (dataUpdate) => void;
  fundExp;
  setFundExp;
  curve;
  setCurve;
  party;
  setParty;
}

const CustomInfoCurve: React.FC<ModalProps> = ({
  isOpen,
  coin,
  closeModal,
  onConfirm,
  fundExp,
  setFundExp,
  curve,
  setCurve,
  party,
  setParty,
}) => {
  return (
    <div
      className={twMerge(
        'fixed w-screen inset-0 flex items-center justify-center z-50 backdrop-blur-md',
        !isOpen && 'hidden',
      )}
    >
      <div className="flex w-full max-w-[600px] flex-col p-6 rounded-lg gap-8 bg-[#13141D] relative justify-center">
        <button
          onClick={() => closeModal()}
          className="absolute top-6 right-6 text-gray-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
            className="w-6 h-6 hover:brightness-150"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <div className="text-[18px] text-[#E8E9EE] text-left">
          Strategy config
        </div>
        <FormDeFaiAgentInfo
          fundExp={fundExp}
          setFundExp={setFundExp}
          curve={curve}
          setCurve={setCurve}
          party={party}
          setParty={setParty}
          coinInfo={null}
        />
        <button
          onClick={() =>
            onConfirm({
              curve,
              fundExp,
              party,
            })
          }
          className="disabled:opacity-75 w-full disabled:cursor-not-allowed uppercase p-1 rounded border-[2px] border-solid border-[rgba(255,255,255,0.25)] cursor-pointer hover:border-[rgba(255,255,255)] transition-all ease-in duration-150"
        >
          <div className="text-center uppercase rounded bg-white px-6 py-2 text-[#080A14]">
            Confirm
          </div>
        </button>
      </div>
    </div>
  );
};

export default CustomInfoCurve;
